class HeuristicsService {
    constructor($http, $q) {
        this.$http = $http;
        this.$q = $q;
    };

    updateAspectDefinitions(aspect) {
        let self = this;
        return self.$http({
            method: 'POST',
            url: '/api/learning_engagement/aspect/' + aspect.id,
            data: aspect,
            headers: {
                'Content-Type': 'application/json',
                'authentication': localStorage.getItem('kes_token')
            }
        })
        .then(function successCallback(response) {
            return response.data;
        },
        function errorCallback(response) {
            return self.$q.reject(response);
        });
    };

    createQuestion(question) {
        let self = this;
        return self.$http({
            method: 'POST',
            url: '/api/learning_engagement/question',
            data: question,
            headers: {
                'Content-Type': 'application/json',
                'authentication': localStorage.getItem('kes_token')
            }
        }).then(function successCallback(response) {
            return response.data;
        },
        function errorCallback(response) {
            return self.$q.reject(response);
        });
    }


    updateQuestion(question) {
        let self = this;
        return self.$http({
            method: 'POST',
            url: '/api/learning_engagement/question/' + question.id,
            data: question,
            headers: {
                'Content-Type': 'application/json',
                'authentication': localStorage.getItem('kes_token')
            }
        })
        .then(function successCallback(response) {
            return response.data;
        },
        function errorCallback(response) {
            return self.$q.reject(response);
        });
    };


    updateHeuristic(heuristic) {
        let self = this;
        return self.$http({
            method: 'POST',
            url: `/api/learning_engagement/heuristic${heuristic.id ? `/${heuristic.id}` : ''}`,
            data: heuristic,
            headers: {
                'Content-Type': 'application/json',
                'authentication': localStorage.getItem('kes_token')
            }
        })
        .then(function successCallback(response) {
            return response.data;
        },
        function errorCallback(response) {
            return self.$q.reject(response);
        });
    };

    removeQuestion(question) {
        let self = this;
        return self.$http({
            method: 'DELETE',
            url: '/api/learning_engagement/question/' + question.id,
            data: {id: question.id},
            headers: {
                'Content-Type': 'application/json',
                'authentication': localStorage.getItem('kes_token')
            }
        })
        .then(function successCallback(response) {
            return response.data;
        },
        function errorCallback(response) {
            return self.$q.reject(response);
        });
    };

    removeHeuristic(heuristic) {
        let self = this;
        return self.$http({
            method: 'DELETE',
            url: `/api/learning_engagement/heuristic/${heuristic.id}`,
            data: heuristic.id,
            headers: {
                'Content-Type': 'application/json',
                'authentication': localStorage.getItem('kes_token')
            }
        })
        .then(function successCallback(response) {
            return response.data;
        },
        function errorCallback(response) {
            return self.$q.reject(response);
        });
    };

    getAllAspects() {
        let self = this;
        return self.$http({
            method: 'GET',
            url: '/api/learning_engagement/aspect',
            headers: {
                'Content-Type': 'application/json',
                'authentication': localStorage.getItem('kes_token')
            },
            data: {}
        })
        .then(function successCallback(response) {
            return response.data;
        },
        function errorCallback(response) {
            return self.$q.reject(response);
        });
    };
}

export default HeuristicsService;


// WEBPACK FOOTER //
// ./src/app/pages/manageSkills/services/heuristicsService.js